/**
 * Utility class providing helper methods for working with date operations.
 */
export class DateUtil {
  private static readonly DATE_TIME_FORMATTER = new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  private static readonly TIME_FORMATTER = new Intl.DateTimeFormat("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  /**
   * Format a Date object into HH:mm (24-hour)
   * using UK locale formatting (en-GB).
   */
  static formatTime(date: Date): string {
    return DateUtil.TIME_FORMATTER.format(date);
  }

  /**
   * Format date + time (DD-MMM-YYYY HH:mm)
   */
  static formatDateTime(date: Date): string {
    const parts = DateUtil.DATE_TIME_FORMATTER.formatToParts(date);
    const values: Record<string, string> = {};
    for (const part of parts) {
      if (part.type !== "literal") {
        values[part.type] = part.value;
      }
    }
    const day = values.day ?? "";
    const month = values.month ?? "";
    const year = values.year ?? "";
    const hour = values.hour ?? "";
    const minute = values.minute ?? "";
    return `${day}-${month}-${year} ${hour}:${minute}`;
  }

  static formatDateTimeInMillisecond(dateInMillisecond?: string | number | null): string {
    if (null === dateInMillisecond || undefined === dateInMillisecond || '' === dateInMillisecond) {
      return '-';
    }

    const date = new Date(dateInMillisecond);
    return DateUtil.formatDateTime(date);
  }
}
